
// Import builderFetch
import { builderFetch } from '../../utils';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

/**
 * Sets a new recipe title (post_title)
 *
 * @param {String} newTitle The recipe title
 * @return {Promise} The apiFetch promise
 */
const setRecipeTitle = ( newTitle ) => {
	// Event name
	const eventName = 'uap/builder/core/set-recipe-title';

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'change_post_title',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			post_ID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			post_title: newTitle
		},
		snackbar: {
			loading: escapeHTML( __( 'Updating recipe title', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Recipe title updated successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					recipeTitle: newTitle
				}
			} ) );
		}

		return response;
	} );
}

export default setRecipeTitle;
